(() => {
  'use strict';

  const eventNames = [
    'ogh_product_viewed',
    'ogh_comparison_viewed',
    'ogh_application_selected',
    'ogh_manual_downloaded',
    'ogh_power_plan_calculated',
    'ogh_product_finder_completed',
    'ogh_search_submitted',
    'ogh_search_no_results',
    'ogh_faq_expanded',
    'ogh_contact_initiated',
    'ogh_add_to_cart_submitted',
  ];
  const allowedDetailKeys = ['page_type', 'resource_handle', 'tool'];
  const queue = window.oghAnalyticsQueue = window.oghAnalyticsQueue || [];
  document.documentElement.dataset.oghEventsReady = 'true';

  const safeDetail = (detail = {}) => allowedDetailKeys.reduce((result, key) => {
    if (typeof detail[key] === 'string' && detail[key]) result[key] = detail[key];
    return result;
  }, {});

  eventNames.forEach((name) => {
    document.addEventListener(name, (event) => {
      queue.push({
        event: name,
        event_version: 1,
        occurred_at: new Date().toISOString(),
        ...safeDetail(event.detail),
      });
    });
  });

  const emit = (name, detail = {}) => {
    if (!eventNames.includes(name)) return;
    document.dispatchEvent(new CustomEvent(name, { detail: safeDetail(detail) }));
  };

  window.oghAnalytics = Object.freeze({ emit });

  const initialize = () => {
    const main = document.querySelector('main[data-page-type]');
    if (!main) return;

    const context = {
      page_type: main.dataset.pageType || '',
      resource_handle: main.dataset.resourceHandle || '',
    };

    if (context.page_type === 'product' && main.dataset.resourceStatus === 'verified') {
      emit('ogh_product_viewed', context);
    }
    if (context.page_type === 'page' && context.resource_handle === 'compare') {
      emit('ogh_comparison_viewed', context);
    }
    if (context.page_type === 'search' && main.querySelector('[data-ogh-search-empty]')) {
      emit('ogh_search_no_results', { page_type: 'search' });
    }

    main.addEventListener('submit', (event) => {
      const form = event.target.closest('form');
      if (!form) return;
      const action = form.getAttribute('action') || '';
      if (action.includes('/search')) emit('ogh_search_submitted', { page_type: 'search' });
      if (action.includes('/contact')) emit('ogh_contact_initiated', context);
      if (action.includes('/cart/add')) emit('ogh_add_to_cart_submitted', context);
    });

    main.addEventListener('click', (event) => {
      const applicationLink = event.target.closest('[data-ogh-application-link]');
      if (applicationLink) {
        const path = new URL(applicationLink.href, window.location.origin).pathname;
        emit('ogh_application_selected', {
          page_type: context.page_type,
          resource_handle: path.split('/').filter(Boolean).pop() || '',
        });
      }
      if (event.target.closest('[data-ogh-document-link]')) {
        emit('ogh_manual_downloaded', context);
      }
    });

    main.addEventListener('toggle', (event) => {
      if (event.target.matches('.ogh-faq details') && event.target.open) {
        emit('ogh_faq_expanded', context);
      }
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
